import React, { useEffect, useState } from 'react';
import styles from './CustomPagination.module.scss';
import ReactPaginate from 'react-paginate';
import nextIcon from '../../../assets/icons/next_icon.svg';
import doubleArrow from '../../../assets/icons/double_right.svg';
interface CustomPaginationProps<T> {
  items: T[];
  itemsPerPage: number;
  children: (paginatedItems: T[]) => React.ReactNode;
  style?: React.CSSProperties;
}

function CustomPagination<T>({ items, itemsPerPage, children, style }: CustomPaginationProps<T>) {
  const [currentPage, setCurrentPage] = useState(0);
  const startIdx = currentPage * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const currentPaginatedItems = items.slice(startIdx, endIdx);
  const totalPages = Math.ceil(items.length / itemsPerPage);

  const handlePageChange = (selectedObject: { selected: number }) => {
    setCurrentPage(selectedObject.selected);
  };

  const pageRanges = {
    0: 5,
    1: 4,
    2: 4,
    3: 3,
    [totalPages - 3]: 5,
    [totalPages - 2]: 5,
    [totalPages - 1]: 5,
  };
  useEffect(() => {
    setCurrentPage(0);
  }, [items]);

  if (items.length < 1) {
    return null;
  }
  return (
    <div className={styles.paginationContainer} style={style}>
      <div className={styles.itemsContainer}>{children(currentPaginatedItems)}</div>
      <div className={styles.pagination}>
        {items.length > 2 && (
          <img
            className={`${styles.firstItem} ${styles.rotate}`}
            src={doubleArrow}
            onClick={() => setCurrentPage(0)}
            alt="doubleArrow"
          />
        )}
        <ReactPaginate
          previousLabel={<img className={styles.rotate} src={nextIcon} alt="Next" />}
          nextLabel={<img src={nextIcon} alt="Next" />}
          breakLabel={'...'}
          pageCount={totalPages}
          onPageChange={handlePageChange}
          pageRangeDisplayed={pageRanges[currentPage] || 2}
          marginPagesDisplayed={1}
          forcePage={currentPage}
        />
        {items.length > 2 && (
          <img
            className={styles.lastItem}
            src={doubleArrow}
            onClick={() => setCurrentPage(totalPages - 1)}
            alt="doubleArrow"
          />
        )}
      </div>
    </div>
  );
}

export default CustomPagination;
